import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/jobsearch/icon-sort.svg'
import _imports_1 from '@/assets/img/jobsearch/icon-display.svg'


const _withScopeId = n => (_pushScopeId("data-v-d9cdb3ae"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "l-wrapper",
  style: {"background-color":"#f3f3f3"}
}
const _hoisted_2 = { class: "l-wrapper_main" }
const _hoisted_3 = { class: "p-jobsearch" }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "p-jobsearch-inner" }
const _hoisted_6 = { class: "p-jobsearch-header" }
const _hoisted_7 = { class: "p-jobsearch-header_inner" }
const _hoisted_8 = { class: "p-jobsearch-tab" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", { class: "p-jobsearch-tab_item __current" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-tab_item_inner" }, "紹介求人")
], -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-tab_item_inner" }, "公開求人", -1))
const _hoisted_11 = { class: "p-jobsearch-control" }
const _hoisted_12 = { class: "p-jobsearch-control_inner" }
const _hoisted_13 = { class: "p-jobsearch-control_count" }
const _hoisted_14 = { class: "p-jobsearch-control_count_highlight" }
const _hoisted_15 = { class: "p-jobsearch-control_buttons" }
const _hoisted_16 = {
  class: "p-jobsearch-control_buttons_sort js-jobsearch-select",
  "data-select": "sort"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "p-jobsearch-control_buttons_sort_icon",
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_18 = { class: "js-jobsearch-select_label" }
const _hoisted_19 = { class: "p-jobsearch-control_buttons_sort_list_item" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sort1" }, "紹介日順", -1))
const _hoisted_21 = { class: "p-jobsearch-control_buttons_sort_list_item" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "sort2" }, "おすすめ順", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "p-jobsearch-control_buttons_display js-modal-open-button",
  type: "button",
  "data-modal-target": "modalDisplay"
}, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "p-jobsearch-control_buttons_display_icon",
    src: _imports_1,
    alt: ""
  }),
  /*#__PURE__*/_createTextVNode("表示設定")
], -1))
const _hoisted_24 = { class: "p-jobsearch-control_inner" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "switch" }, "まとめて選択", -1))
const _hoisted_26 = { class: "p-jobsearch-control_inner __vertical" }
const _hoisted_27 = { class: "p-jobsearch-control_term" }
const _hoisted_28 = { class: "p-jobsearch-control_check" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "表示されている紹介求人を選択", -1))
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-jobsearch-control_term" }, "※一括操作は20件まで可能です。21件以上表示された状態で一括選択を行うと上部から20件が選択されます。", -1))
const _hoisted_32 = {
  key: 0,
  class: "p-jobsearch-list"
}
const _hoisted_33 = { class: "p-jobsearch-list_more" }
const _hoisted_34 = ["disabled"]

import JobListItem from '@/components/JobListItem.vue';
import JobSearchFooter from '@/components/JobSearchFooter.vue';
import Loading from '@/components/Loading.vue';

// 「表示設定」モーダル
import { computed, nextTick, onActivated, onDeactivated, ref } from 'vue';
import JobSearchFilterModals from '@/components/JobSearchFilterModals.vue';
import { useStore } from 'vuex';
import { Job } from '@/types';
import { TrnShintyokuSelectRequest } from '@/types/request';
import { RouterLink, useRoute, useRouter } from 'vue-router';
import { datefnsFormat, separatorDate } from '@/utils/dateFormat';
import { getJobSearchListService, setFavoriteService } from '@/api/services/shintyokuService';
import { MYPAGE_CONSTANTS } from '@/constants/mypage';
import { jobSearchUtils } from '@/utils/jobSearch';


export default /*#__PURE__*/_defineComponent({
  __name: 'JobSearchView',
  setup(__props) {

const isDisplayModalOpen = ref(false); // 「表示設定」モーダルの表示状態を管理
const appliedFilters = ref<any>(null);
const appliedDisplayPeriod = ref('');
const appliedStartDate = ref<Date | null>(null);
const appliedEndDate = ref<Date | null>(null);
const shintyokuSelectParams = ref<TrnShintyokuSelectRequest>({});

// 「まとめて選択」トグルの状態を管理するref
const isBulkSelectionEnabled = ref(false); // 初期値はOFF

const isAction = ref(true);

// 選択された求人件数をカウントする算出プロパティ
const selectedJobCount = computed(() => {
  return jobList.value.filter(job => job.checked).length;
});

const isAnyCheckboxChecked = computed(() => {
  return jobList.value.some(job => job.checked === true);
});

const updateJobChecked = async (orderId: number, checked: boolean) => {
  const job = jobList.value.find(j => Number(j.orderId) === orderId);
  if (job) {
    // 20件の上限を超えてチェックしようとした場合
    if (checked && selectedJobCount.value >= 20) {
      await store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.ORDER_BULK_LIMIT.SELECT_CHECK});
    } else {
      // それ以外の場合はチェックボックスの状態を更新
      job.checked = checked;
    }
  }
};

const store = useStore();

// 求人リストのダミーデータ
const jobList = ref<Job[]>([]);

const formattedStartDate = computed(() => {
  return appliedStartDate.value ? datefnsFormat(appliedStartDate.value, 'yyyy.MM.dd') : '';
});

const formattedEndDate = computed(() => {
  return appliedEndDate.value ? datefnsFormat(appliedEndDate.value, 'yyyy.MM.dd') : '';
});

function updateShintyokuSelectParams(
  newParams: Partial<TrnShintyokuSelectRequest> = {}, 
  mode: 'replace' | 'merge' = 'merge'
): TrnShintyokuSelectRequest {
  let updatedParams: TrnShintyokuSelectRequest;
  
  if (mode === 'replace') {
    updatedParams = { ...newParams };
  } else {
    updatedParams = { ...shintyokuSelectParams.value };
    Object.entries(newParams).forEach(([key, value]) => {
      const paramKey = key as keyof TrnShintyokuSelectRequest;
      if (typeof value === 'string' || typeof value === 'number' || value === undefined) {
        updatedParams[paramKey] = value as any;
      }
    });
  }
  // Update state
  shintyokuSelectParams.value = updatedParams;

  return updatedParams;
}

// JobListItemからのfavoriteイベントを処理
const updateJobFavorite = async (id: number, favorite: boolean, index: number) => {
  isAction.value = false;
  const job = jobList.value.find(j => Number(j.orderId) === id);
  if (job) {
    job.isFavorite = favorite;
    const orderIds: number[] = [];
    orderIds.push(Number(job.orderId));
    const detailResp = await setFavoriteService({
      orderIds: orderIds,
      isFavorite: favorite
    });
    if(detailResp)
    {
      jobSearchUtils.showMessageForInvalidOrders(store, jobList.value, detailResp);
      if (detailResp.orderId.length){
        if(job.isFavorite)
        {
          store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.FAVORITE_DONE});
        }
        else
        {
          store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE});
        }
      }
      else
      {
        job.isFavorite = !favorite;
      }
    }
    else
    {
      job.isFavorite = !favorite;
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.ERROR_FAVORITE});
    }
  }
  isAction.value = true;
};

const bulkUpdateJobFavorite = async (params: {isFavorite: boolean})=>{
  if(!isAction.value)
  {
    return;
  }
  isAction.value = false;
  const checkedOrderIds = jobList.value.filter(j => j.checked).map(j => Number(j.orderId));
  if (checkedOrderIds.length){
    const detailResp = await setFavoriteService({
      orderIds: checkedOrderIds,
      isFavorite: params.isFavorite
    });
    if(detailResp)
    {
      jobSearchUtils.showMessageForInvalidOrders(store, jobList.value, detailResp, true);
      // update states
      jobList.value.filter(j => j.checked).forEach((j)=>{
        if(j.checked)
        {
          if(detailResp.orderId.includes(j.orderId))
          {
            j.isFavorite = params.isFavorite;
          }
        }
      });
      if (detailResp.orderId.length){
        if(params.isFavorite)
          store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.FAVORITE_DONE});
        else
          store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.UN_FAVORITE_DONE});
      }
    }
    else
    {
      store.dispatch('toasts/appendTimeToast', {label: MYPAGE_CONSTANTS.STRING.ERROR_FAVORITE});
    }    
  }
  isAction.value = true;
};

// 「表示されている紹介求人を選択」チェックボックスの処理
const handleCheckAllJob = (event: Event) => {
  const checked = (event.target as HTMLInputElement).checked;
  // チェックがONになった場合
  if (checked) {
    // 20件をチェック
    jobList.value.slice(0, 20).forEach(job => {
      job.checked = true;
    });
    jobList.value.slice(20).forEach(job => {
      job.checked = false;
    });
  } else {
    // チェックがOFFになった場合、全てのチェックを外す
    jobList.value.forEach(job => {
      job.checked = false;
    });
  }
};

// 「表示設定」モーダルを閉じたタイミング処理(フィルタ適用内容を取得)
const handleApplyFilters = async (filters: { checkboxes: any, displayPeriod: string, startDate: Date | null, endDate: Date | null, isChanged: boolean | null}) => {
  if (!filters.isChanged) return;

  appliedFilters.value = filters.checkboxes;
  appliedDisplayPeriod.value = filters.displayPeriod;
  appliedStartDate.value = filters.startDate;
  appliedEndDate.value = filters.endDate;

  const params = getParamsFromFilter(filters);
  updateShintyokuSelectParams(params, 'replace');
  shintyokuSelectParams.value.pageCursor = {};
  await loadJobList(params);

  // hide footer
  isBulkSelectionEnabled.value = false;
  // save current filter to session
  sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_FILTERS, JSON.stringify(filters));
};

function getParamsFromFilter(filters: any){
  // build the search params
  const checkboxes = filters.checkboxes;
  const params : TrnShintyokuSelectRequest = {};
  // 表示期間
  if (appliedStartDate.value && appliedEndDate.value) {
    params.displayTime = {
      from: datefnsFormat(appliedStartDate.value, 'yyyy/MM/dd'),
      to: datefnsFormat(appliedEndDate.value, 'yyyy/MM/dd'),
    };
  }
  // 担当者おすすめ
  params.matchingType = '';
  if (checkboxes.recommendationFromStaff) params.matchingType += '1';
  // AIおすすめ
  if (checkboxes.recommendationByAI) params.matchingType += '2';
  // 新着レコメンド
  if (checkboxes.newArrivals) params.matchingType += '3';
  // 担当者コメントあり
  if (checkboxes.withStaffComment) params.recommend = 1;
  // 未読の求人のみ表示
  if (checkboxes.unreadJobsOnly) params.onlyUnreadOrder = 1;
  // 募集終了求人を除く
  if (checkboxes.excludeEndedApplications) params.notOrderClose = 1;

  // Keep previous sort option
  params.orderBy = shintyokuSelectParams.value.orderBy;
  return params;
}


const router = useRouter();
const isLoading = ref(false);
const totalCount = ref(0);

const hasMore = ref(false);

const isInitFilter = ref(false);
const minDate = ref<Date | null>(null);
const maxDate = ref<Date | null>(null);
const isJobListLoaded = ref(false);
const savedScrollTop = ref(0);

const sortState = ref({
  isOpen: false,
  selectedText: '紹介日順',
  selectedValue: 'asc',
});

async function sortJobList(isDefaultSort = true){
  const params = getParamsFromSort(isDefaultSort);
  updateShintyokuSelectParams(params, 'merge');
  shintyokuSelectParams.value.pageCursor = {};
  loadJobList(params);
  // save current params to session
  sessionStorage.setItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_SORT, JSON.stringify(sortState.value));
}

function getParamsFromSort(isDefaultSort = true){
  const params: TrnShintyokuSelectRequest = {};
  params.page = 1;
  if (isDefaultSort){
    params.orderBy = 'asc';
    sortState.value.selectedText = '紹介日順';
  } else {
    params.orderBy = 'desc';
    sortState.value.selectedText = 'おすすめ順';
  }
  sortState.value.selectedValue = params.orderBy;
  sortState.value.isOpen = false;
  return params;
}

const handleOutsideDropdownClick = (event: MouseEvent) => {
  const selectContainer = document.querySelector('.js-jobsearch-select');
  if (!selectContainer) return;
  if (!selectContainer.contains(event.target as Node) && sortState.value.isOpen) {
    sortState.value.isOpen = false;
  }
};

async function loadJobList(params?: TrnShintyokuSelectRequest, isFullPageLoading = true, isCount = false){
  isLoading.value = isFullPageLoading;
  let isLoadOrder = true;

  try{
    let requestParams : TrnShintyokuSelectRequest;
    if(isCount){
      requestParams = {
        ...({}),
      };
      isLoadOrder = false;
    } else {
      requestParams = {
        ...shintyokuSelectParams.value,
        ...(params || {}),
      };
    }

    const jobSearchState = await getJobSearchListService(requestParams, isLoadOrder);

    const fetchedJobs = jobSearchState.shintyokuList;

    if (!isCount && fetchedJobs && fetchedJobs.length > 0) {
      if (isFullPageLoading) {
        jobList.value = fetchedJobs;
      } else {
        jobList.value = [...jobList.value, ...fetchedJobs];
      }
    }
    totalCount.value = jobSearchState.totalCount;
    if(isCount) return;

    shintyokuSelectParams.value.pageCursor = jobSearchState.pageCursor;
    hasMore.value = jobSearchState.hasMore;

    // 表示設定
    const filterAvailable = jobSearchState.filterAvailable;
    // 表示期間
    minDate.value = filterAvailable.minDate!;
    maxDate.value = filterAvailable.maxDate!;
    if(filterAvailable && isInitFilter.value){
      isInitFilter.value = false;

      if(!appliedDisplayPeriod.value){
        appliedStartDate.value = new Date();
        appliedStartDate.value.setMonth(appliedStartDate.value.getMonth() - 3);
        appliedEndDate.value = new Date();
      }
      if(!appliedStartDate.value){
        appliedStartDate.value = new Date();
        appliedStartDate.value.setMonth(appliedStartDate.value.getMonth() - 3);
      }
      if(!appliedEndDate.value){
        appliedEndDate.value = new Date();
      }
      if(minDate.value > appliedStartDate.value && minDate.value < appliedEndDate.value){
        appliedStartDate.value = minDate.value;
      }
      if(maxDate.value > appliedStartDate.value && maxDate.value < appliedEndDate.value){
        appliedEndDate.value = maxDate.value;
      }
      appliedDisplayPeriod.value = separatorDate(appliedStartDate.value) + ' - ' + separatorDate(appliedEndDate.value);
    }
    isJobListLoaded.value = true;

  } catch (error) {
    // TODO: Error handle
  }

  if (isFullPageLoading) {
    isLoading.value = false;
    // scroll to top
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

}

const isLoadingMore = ref(false);

async function nextPage(){
  if (jobList.value.length < totalCount.value) {
    isLoadingMore.value = true;
    updateShintyokuSelectParams({});
    await loadJobList({}, false);
    isLoadingMore.value = false;
  }
}

function isFilterOn(){
  return appliedFilters.value && (appliedFilters.value.recommendationFromStaff
        || appliedFilters.value.recommendationByAI
        || appliedFilters.value.newArrivals
        || appliedFilters.value.withStaffComment
        || appliedFilters.value.unreadJobsOnly
        || appliedFilters.value.excludeEndedApplications
        || appliedDisplayPeriod.value);
}

function turnAction(turnValue: boolean){
  isAction.value = turnValue;
}

const route = useRoute();
onActivated(async () => {
  isLoading.value = true;
  document.addEventListener('click', handleOutsideDropdownClick);

  // Keep the page state when has back event
  const orderChange = store.getters['favorites/favorites'];

  // Keep the page state when has back event
  if(route.meta.isBack && isJobListLoaded.value) {
    if(orderChange.orderId) {
      applyFavoriteChangeByOrderId(orderChange.orderId, orderChange.isLike);
      await nextTick();
    }
    isLoading.value = false;

    if(orderChange.orderId) {
      await nextTick();
      window.scrollTo({ top: savedScrollTop.value, behavior: 'smooth' });
      await store.dispatch('favorites/clearFavorite');
    }

    return;
  }
  await store.dispatch('favorites/clearFavorite');

  // Reset ref before set new value
  resetRefs();

  await handleOnActive();
  
  if(!isFilterOn()){
    await loadJobList({}, false, true);
    if (totalCount.value == 0){
      router.push({name: 'h01', query:{jobSearchCnt: '0'}});
    }
  }

  await loadJobList();
});

function applyFavoriteChangeByOrderId(orderId: string, isLike: boolean) {
  const idx = getOrderIndexByOrderId(orderId);
  if (idx >= 0) {
    const updated = {
      ...jobList.value[idx],
      isFavorite: isLike,
    };
    jobList.value[idx] = updated;
    jobList.value = [...jobList.value];
  }
}

function getOrderIndexByOrderId(orderId: string): number {
  return jobList.value.findIndex(j => String(j.orderId) === String(orderId));
}

const handleSaveScrollTop = () => {
  savedScrollTop.value = window.scrollY || window.pageYOffset || 0;
};

onDeactivated(() => {
  document.removeEventListener('click', handleOutsideDropdownClick);
});

const resetRefs = () => {
  isBulkSelectionEnabled.value = false;
  sortState.value = {
    isOpen: false,
    selectedText: '紹介日順',
    selectedValue: 'asc',
  };
  shintyokuSelectParams.value = {};
}

const handleOnActive = async() => {
  try{
    // get previours sorting
    const sort = JSON.parse(sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_SORT) || 'false');
    if (sort) {
      sortState.value = sort;
      const isDefaultSort = sortState.value.selectedValue == 'asc';
      const params = getParamsFromSort(isDefaultSort);
      updateShintyokuSelectParams(params, 'merge');
    }

    // get previours filters
    const filters = JSON.parse(sessionStorage.getItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_FILTERS) || 'false');
    if (filters) {
      appliedFilters.value = filters.checkboxes;
      appliedDisplayPeriod.value = filters.displayPeriod;
      if (filters.startDate){
        appliedStartDate.value = new Date(filters.startDate);
      }
      if (filters.endDate){
        appliedEndDate.value = new Date(filters.endDate);
      }
      const params = getParamsFromFilter(filters);
      updateShintyokuSelectParams(params, 'replace');
    }

  } catch (err){
    console.error(err);
    sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_FILTERS);
    sessionStorage.removeItem(MYPAGE_CONSTANTS.SESSION_KEY.JOBSEARCH_SORT);
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("main", _hoisted_3, [
          (!isLoading.value)
            ? (_openBlock(), _createElementBlock("form", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _hoisted_9,
                        _createVNode(_unref(RouterLink), {
                          class: "p-jobsearch-tab_item",
                          to: {name: 'h01'}
                        }, {
                          default: _withCtx(() => [
                            _hoisted_10
                          ]),
                          _: 1
                        })
                      ]),
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, [
                          _createElementVNode("p", _hoisted_13, [
                            _createTextVNode("全"),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(totalCount.value), 1),
                            _createTextVNode("件")
                          ]),
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _createElementVNode("div", {
                                class: "p-jobsearch-control_buttons_sort_btn js-jobsearch-select_btn",
                                onClick: _cache[0] || (_cache[0] = () => sortState.value.isOpen = !sortState.value.isOpen)
                              }, [
                                _hoisted_17,
                                _createElementVNode("span", _hoisted_18, _toDisplayString(sortState.value.selectedText), 1)
                              ]),
                              _createElementVNode("div", {
                                class: _normalizeClass(["p-jobsearch-control_buttons_sort_list js-jobsearch-select_list", {__opened: sortState.value.isOpen}])
                              }, [
                                _createElementVNode("div", _hoisted_19, [
                                  _hoisted_20,
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "sort",
                                    id: "sort1",
                                    onChange: _cache[1] || (_cache[1] = ($event: any) => (sortJobList(true)))
                                  }, null, 32)
                                ]),
                                _createElementVNode("div", _hoisted_21, [
                                  _hoisted_22,
                                  _createElementVNode("input", {
                                    type: "radio",
                                    name: "sort",
                                    id: "sort2",
                                    onChange: _cache[2] || (_cache[2] = ($event: any) => (sortJobList(false)))
                                  }, null, 32)
                                ])
                              ], 2)
                            ]),
                            _hoisted_23
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_24, [
                          _createElementVNode("div", {
                            class: _normalizeClass([{invisibility: !totalCount.value}, "p-jobsearch-control_switch"])
                          }, [
                            _withDirectives(_createElementVNode("input", {
                              type: "checkbox",
                              checked: "",
                              id: "switch",
                              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((isBulkSelectionEnabled).value = $event))
                            }, null, 512), [
                              [_vModelCheckbox, isBulkSelectionEnabled.value]
                            ]),
                            _hoisted_25
                          ], 2),
                          _createVNode(_unref(RouterLink), {
                            class: "p-jobsearch-control_link",
                            to: {name: 'm00'}
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("応募しない求人一覧")
                            ]),
                            _: 1
                          })
                        ]),
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("p", _hoisted_27, "表示期間: " + _toDisplayString(_unref(formattedStartDate)) + " - " + _toDisplayString(_unref(formattedEndDate)), 1),
                          _withDirectives(_createElementVNode("label", _hoisted_28, [
                            _createElementVNode("input", {
                              class: "js-check-alljob",
                              type: "checkbox",
                              name: "",
                              onChange: handleCheckAllJob
                            }, null, 32),
                            _hoisted_29,
                            _hoisted_30,
                            _hoisted_31
                          ], 512), [
                            [_vShow, isBulkSelectionEnabled.value]
                          ])
                        ])
                      ])
                    ])
                  ]),
                  (jobList.value.length > 0 && totalCount.value > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_32, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobList.value, (job, idx) => {
                          return (_openBlock(), _createBlock(JobListItem, {
                            key: job.orderId,
                            job: job,
                            isBulkSelectionEnabled: isBulkSelectionEnabled.value,
                            screenName: "jobSearch",
                            fromScreen: "recommend",
                            "onUpdate:checked": checked => updateJobChecked(Number(job.orderId), checked),
                            "onUpdate:favorite": favorite => updateJobFavorite(Number(job.orderId), favorite, idx),
                            onTurnAction: turnAction,
                            onSaveScrollTop: handleSaveScrollTop
                          }, null, 8, ["job", "isBulkSelectionEnabled", "onUpdate:checked", "onUpdate:favorite"]))
                        }), 128)),
                        _createElementVNode("div", _hoisted_33, [
                          (hasMore.value)
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                disabled: isLoadingMore.value,
                                class: "p-jobsearch-btn __blue __more",
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (nextPage()))
                              }, [
                                _createTextVNode(" 検索結果をもっと見る"),
                                _createElementVNode("span", {
                                  class: _normalizeClass(["p-jobsearch-btn_ico", {'loading-spinner': isLoadingMore.value}])
                                }, null, 2)
                              ], 8, _hoisted_34))
                            : _createCommentVNode("", true)
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(JobSearchFilterModals, {
                  "is-display-modal-open": isDisplayModalOpen.value,
                  "recommendation-from-staff": appliedFilters.value?.recommendationFromStaff ?? true,
                  "recommendation-by-AI": appliedFilters.value?.recommendationByAI ?? true,
                  "new-arrivals": appliedFilters.value?.newArrivals ?? true,
                  "with-staff-comment": appliedFilters.value?.withStaffComment ?? false,
                  "unread-jobs-only": appliedFilters.value?.unreadJobsOnly ?? false,
                  "exclude-ended-applications": appliedFilters.value?.excludeEndedApplications ?? false,
                  "selected-start-date": appliedStartDate.value,
                  "selected-end-date": appliedEndDate.value,
                  "applied-display-period": appliedDisplayPeriod.value,
                  "from-screen": 'jobsearch',
                  "min-date": minDate.value,
                  "max-date": maxDate.value,
                  "onUpdate:isDisplayModalOpen": _cache[5] || (_cache[5] = ($event: any) => (isDisplayModalOpen.value = $event)),
                  onApplyFilters: handleApplyFilters
                }, null, 8, ["is-display-modal-open", "recommendation-from-staff", "recommendation-by-AI", "new-arrivals", "with-staff-comment", "unread-jobs-only", "exclude-ended-applications", "selected-start-date", "selected-end-date", "applied-display-period", "min-date", "max-date"])
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(JobSearchFooter, {
        isBulkSelectionEnabled: isBulkSelectionEnabled.value && _unref(isAnyCheckboxChecked),
        jobs: jobList.value,
        "is-loading": isLoading.value,
        onToggleFavorite: bulkUpdateJobFavorite
      }, null, 8, ["isBulkSelectionEnabled", "jobs", "is-loading"])
    ]),
    _createVNode(Loading, {
      "is-loading": isLoading.value || !isAction.value
    }, null, 8, ["is-loading"])
  ], 64))
}
}

})